/* template */
<template minapp="mpx" xlang="wxml"><div class="es-search-input__search-container"><es-icon color="#000000" name="search" size="20" class="es-search-input__search-icon"/><mpx-input type="text" :value="keywords" mpxModelEvent="input" @mpxModel='__model("keywords", $event, ["value"], undefined)' :class="(borderClass)" :placeholder="(placeholder)" @input="onInput" @focus="onFocus" @blur="onBlur" class="es-search-input__search-input"/><mpx-view @tap="clear" v-show="(keywords)" class="clear"><es-icon color="#cccccc" name="close-circle-filled" size="20"/></mpx-view></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mdee11fea"}'>
  +b('search-input')
    +e('search-container')
      display flex
      align-items center
      background #ffffff
      border-radius 8px
      padding 8px 12px 12px

      .clear
        position absolute
        right 26px

    +e('search-icon')
      position absolute
      left 26px

    +e('search-input')
      color #333333
      height 20px
      line-height 20px
      font-size 14px
      background #f4f5f6
      height 44px
      padding 0 44px 0 40px
      border-radius 8px
      outline-color #1473ff
      flex 1
      border 1px solid transparent
      outline none
    +e('search-input-focus')
      border 1px solid #1473ff
    
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mdee11fea"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexdee11fea%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexdee11fea%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mdee11fea"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexdee11fea/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'mpx-input':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-input.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
